<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">
        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
          <label>Código</label>
          <b-form-input type="text"
                        placeholder="Código"
                        v-model="form.cd"
                        name="cd"
                        >
          </b-form-input>
          <b-form-feedback class="text-danger" v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>

            <label>Descrição</label>
            <b-form-input type="text"
                          placeholder="Descrição"
                          v-model="form.descr"
                          name="descr"
                          >
            </b-form-input>
            <b-form-feedback class="text-danger" v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>

            <label>Código ERP</label>
            <b-form-input type="text"
                          placeholder="Código ERP"
                          v-model="form.cd_erp"
                          name="cd_erp"
                          >
            </b-form-input>
            <b-form-feedback class="text-danger" v-text="form.errors.get('cd_erp')" v-if="form.errors.has('cd_erp')"></b-form-feedback>

            <label>Status</label>
            <multiselect v-model="statusSelected"
            :options="optionsLivStatus"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            ></multiselect>
            <b-form-feedback class="text-danger" v-text="form.errors.get('status.value')" v-if="form.errors.has('status.value')"></b-form-feedback>

            <label>Componente de Frete <span v-b-tooltip title="Se Sim, descrição não pode ultrapassar 15 caracteres. Usado no Comp. de Frete do CTE" placement="top">[?]</span></label>
            <multiselect v-model="compFreteSelected"
            :options="optionsLivisCFrete"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            ></multiselect>
            <b-form-feedback class="text-danger" v-text="form.errors.get('is_cfrete.value')" v-if="form.errors.has('is_cfrete.value')"></b-form-feedback>

            <label>Tipo de Custo</label>
            <multiselect v-model="tpCustoSelected"
            :options="optionsParamCusto"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            ></multiselect>
            <b-form-feedback class="text-danger" v-text="form.errors.get('partipcus.value')" v-if="form.errors.has('partipcus.value')"></b-form-feedback>

            <label>Tipo de Rateio</label>
            <multiselect v-model="tpRateioSelected"
            :options="optionsParamRateio"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            ></multiselect>
            <b-form-feedback class="text-danger" v-text="form.errors.get('partiprat.value')" v-if="form.errors.has('partiprat.value')"></b-form-feedback>

            <label>Mandatório</label>
            <multiselect v-model="mandatorioSelected"
            :options="optionsLivMandatorio"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            ></multiselect>
            <b-form-feedback class="text-danger" v-text="form.errors.get('mandatorio.value')" v-if="form.errors.has('mandatorio.value')"></b-form-feedback>
        </form>

        <div slot="modal-footer" class="w-100">
               <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
               <div class="float-right">
                   <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                   <b-btn @click="showModal=false" variant="secondary">
                     Fechar
                   </b-btn>
                   <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                     Enviar
                   </b-btn>
               </div>
        </div>
    </b-modal>
</template>
<script>
import AvisoErros from '../components/AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        loading: false,
        isDisabled: false,
        loadingData: true,
        showModal: false,
        showModalGrupo: false,
        isFullscreen: false,
        isLoadingPessoa: false,
        optionsLivStatus: [],
        optionsLivMandatorio: [],
        optionsLivisCFrete: [],
        optionsParamCusto: [],
        optionsParamRateio: [],
        activateDesativate: [],
        statusSelected: [],
        compFreteSelected: [],
        tpRateioSelected: [],
        tpCustoSelected: [],
        errors_array: [],
        mandatorioSelected: [],
        helpForm: new Form({
            statusRecord: [],
            params: []
        }),
        form: new Form({
            cd: '',
            descr: '',
            cd_erp: '',
            status: '',
            mandatorio: '',
            is_cfrete: '',
            partipcus_id: '',
            partiprat_id: '',
            custo_id: ''
        }),
        fields: [],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
   }
},
watch: {
    statusSelected(obj) {
        this.form.status = obj.value;
    },
    compFreteSelected(obj) {
        this.form.is_cfrete = obj.value;
    },
    tpRateioSelected(obj) {
        this.form.partiprat_id = obj.value;
    },
    tpCustoSelected(obj) {
        this.form.partipcus_id = obj.value;
    },
    mandatorioSelected(obj) {
        this.form.mandatorio = obj.value;
    },
},
mounted() {
    this.getLivGeral();
  },
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.custo_id);
        }
    },
    onCreate() {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Cadastrar";
        this.modal_botao = "Cadastrar";
        this.modal_acao = "i";
        this.form.reset();
        this.errors_array = '';
        this.errors_array = [];
        this.statusSelected = [];
        this.compFreteSelected = [];
        this.tpRateioSelected = [];
        this.tpCustoSelected = [];
        this.mandatorioSelected = [];
        this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Alterar";
        this.modal_botao = "Alterar";
        this.modal_acao = "u";
        this.form.reset();
        this.errors_array = '';
        this.errors_array = [];
        this.mandatorioSelected = [];
        this.statusSelected = [];
        this.compFreteSelected = [];
        this.tpRateioSelected = [];
        this.tpCustoSelected = [];
        this.form.cd = data.cd;
        this.form.descr = data.descr;
        this.form.cd_erp = data.cd_erp;
        this.statusSelected = { label: data.status.descr, value: data.status.valor };
        this.mandatorioSelected = { label: data.mandatorio.descr, value: data.mandatorio.valor };
        this.compFreteSelected = { label: data.is_cfrete.descr, value: data.is_cfrete.valor };
        this.tpCustoSelected = { label: data.param_tipo_custo.descr, value: data.param_tipo_custo.partipcus_id };
        this.tpRateioSelected = { label: data.param_tipo_rateio.descr, value: data.param_tipo_rateio.partiprat_id };
        this.form.custo_id = id;
        this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    getLivGeral()
    {
        this.helpForm.get('/api/custo/jsonlistgeral').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>
            {
                this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
            })
            response.mandatorio.forEach((obj)=>
            {
                this.optionsLivMandatorio.push({ label: obj.descr, value: obj.valor })
            })
            response.comp_frete.forEach((obj)=>
            {
                this.optionsLivisCFrete.push({ label: obj.descr, value: obj.valor })
            })
            response.param_rateio.forEach((obj)=>
            {
                this.optionsParamRateio.push({ label: obj.descr, value: obj.partiprat_id })
            })
            response.param_custo.forEach((obj)=>
            {
                this.optionsParamCusto.push({ label: obj.descr, value: obj.partipcus_id })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },

    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
